<template>
  <div>

    <h1>Sandbox</h1>

    <v-row>

      <v-col>

        <v-card title="Base">
          <v-card-text>


          </v-card-text>
        </v-card>

      </v-col>

      <v-col>

      </v-col>

    </v-row>

  </div>
</template>
